<template>
  <router-view v-if="showAppScreen" class="bg-white" />
  <div v-else class="starter-loading-animation">
    <LoadingIndicator :loading="!showAppScreen" size="125px" label=" " />
    <q-img
      src="~assets/gsgroup-logo-white.svg"
      class="floating-logo"
      no-spinner
      fit="contain"
    />
  </div>
</template>
<script>
import { useQuasar } from "quasar";
import { useSettingsStore } from "stores/settings";
import { useAuthStore } from "stores/auth";
import { useBffSettingsStore } from "stores/bffSettings";
import { computed, watch } from "vue";
import { useRoute } from "vue-router";
import LoadingIndicator from "./components/LoadingIndicator.vue";

import dayjs from "dayjs";
import "dayjs/locale/hu";
// import "dayjs/locale/nb";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(timezone);
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
import weekday from "dayjs/plugin/weekday";
dayjs.extend(weekday);
import weekOfYear from "dayjs/plugin/weekOfYear";
dayjs.extend(weekOfYear);
import localizedFormat from "dayjs/plugin/localizedFormat";
dayjs.extend(localizedFormat);
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
import duration from "dayjs/plugin/duration";
dayjs.extend(duration);

export default {
  name: "App",
  components: {
    LoadingIndicator,
  },
  setup() {
    const $q = useQuasar();
    const settingsStore = useSettingsStore();
    const bffSettingsStore = useBffSettingsStore();
    const authStore = useAuthStore();
    const route = useRoute();

    $q.screen.setSizes({ sm: 768, md: 1024, lg: 1440, xl: 1920 });

    const showAppScreen = computed(() => {
      if (route.name === "authentication") {
        return true;
      }
      return authStore.isAuthenticated && authStore.isAuthenticated;
    });

    const authenticationStatus = computed(() => {
      return authStore.isAuthenticated && authStore.isAuthenticated;
    });

    watch(authenticationStatus, (val) => {
      if (val) {
        bffSettingsStore.loadSettings();
      }
    });

    settingsStore.restoreState();

    return {
      showAppScreen,
    };
  },
};
</script>
